import { render, staticRenderFns } from "./UnresponsiveClients.vue?vue&type=template&id=5b3ed1b8&scoped=true&"
import script from "./UnresponsiveClients.vue?vue&type=script&lang=js&"
export * from "./UnresponsiveClients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3ed1b8",
  null
  
)

export default component.exports